import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import { globals } from './js/globals'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['inspi-viewer'] // to use external inspi web-components into vuejs
Vue.mixin({ methods: globals })

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
